import React, { useState } from 'react';

const AntiGOISBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="anti-gois-banner">
      <div className="container">
        <div className="content">
          <p className="text">
            Government officials will NEVER ask you to transfer money or
            disclose bank log-in details over a phone call. Call the 24/7
            ScamShield Helpline at 1799 if you are unsure if something is a
            scam.
          </p>
        </div>
        <a
          href="https://scamshield.gov.sg/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit ScamShield website (opens in a new window)"
          className="scam-shield-button"
        >
          ScamShield
        </a>
        <button
          type="button"
          tabIndex={0}
          aria-label="Dismiss notification temporarily"
          className="dismiss-button"
          onClick={handleDismiss}
        >
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Close</title>
            <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AntiGOISBanner;
